<ng-container *ngIf="compactedAccommodations?.length && selectedAccommodationWithQuotedPrice$ | async as accommodation">
  <lx-card-container
    i18n-title
    type="accommodation"
    [loading]="loading()"
    title="Your Accommodation"
    [attr.data-qa]="'accommodation_header'"
    [disabled]="!accommodation?.code"
    [actionMode]="!!accommodation?.code ? 'edit' : 'add'"
    [endPrice]="accommodation?.endPrice"
    [price]="accommodation?.price"
    [currency]="currency?.()"
    [discount]="accommodation?.discountTotalAsPercentage"
    [gaEventName]="dataLayerEventName$ | async"
    (buttonClick)="openAccommodationsSidePanel()"
  >
    <div class="accommodation__content">
      <ng-container *ngIf="accommodation?.code; else noAccommodation">
        <lx-image
          class="accommodation__img"
          [image]="accommodation.galleryUrls?.[0] || ACCOMMODATIONS_FALLBACK_IMAGE"
          [fallbackImage]="ACCOMMODATIONS_FALLBACK_IMAGE"
          [width]="280"
          [height]="180"
          alt="Accommodation image"
        />

        <div class="accommodation__description">
          <div>
            <div class="accommodation__description__title">
              {{ accommodation.title }}
            </div>

            <div class="accommodation__description__info">
              <lx-accommodation-options [accommodation]="accommodation"></lx-accommodation-options>
            </div>
            <div class="accommodation__description__info accommodation__description__see-more-button">
              <lx-button i18n-text text="See more" [buttonStyle]="'plain-text'" [isUnderlined]="true" (buttonClick)="openAccommodationDetailsSidePanel()">
              </lx-button>
            </div>

            <div class="accommodation__description__duration" *ngIf="tripDates$ | async as tripDates">
              {{ tripDates.accommodationStartDate | lxStudyPeriod : tripDates.accommodationEndDate : accommodation.units }}
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noAccommodation>
        <lx-image class="accommodation__img" alt="" [image]="ACCOMMODATIONS_FALLBACK_IMAGE" [width]="480" [height]="321" />
        <div i18n>Upgrade your accommodation and enjoy more privacy and comfort while you study.</div>
      </ng-template>
    </div>

    <lx-message type="alert" color="blue" data-qa="accommodation_alert" *ngIf="moreAccommodationsDisclaimerShown">
      <ng-container i18n> You're seeing our standard option. Your advisor can help you with other room and meal upgrades! </ng-container>
    </lx-message>
  </lx-card-container>

  <lx-side-panel-gallery
    [visible]="accommodationDetailsDialogVisible"
    (hiddenPanel)="hideAccommodationDetailsDialog()"
    data-qa="accommodation_details_sidePanel"
    [fallbackImage]="ACCOMMODATIONS_FALLBACK_IMAGE"
    [images]="accommodation?.galleryUrls"
  >
    <lx-accommodation-details [accommodation]="accommodation"></lx-accommodation-details>
  </lx-side-panel-gallery>

  <lx-side-panel
    size="large"
    i18n-title
    title="Select an accommodation"
    [visible]="accommodationsDialogVisible"
    (hiddenPanel)="hideAccommodationsDialog()"
    footerButtonText="Apply"
    i18n-footerButtonText
    (footerButtonClicked)="saveSelectedAccommodation()"
    data-qa="accommodation_sidePanel"
  >
    <lx-accommodations
      [accommodations]="compactedAccommodations"
      (accommodationSelected)="updateSelectedAccommodation($event)"
      [accommodationOptional]="accommodationOptional"
      [moreAccommodationsDisclaimerShown]="moreAccommodationsDisclaimerShown"
    ></lx-accommodations>
  </lx-side-panel>
</ng-container>
